import React, { useCallback, useMemo, useState } from 'react';

export const useMapLegendContext = () => {
  const [expandedKey, setExpandedKey] = useState<string>('');
  const [anchorEl, setAnchorEl] = useState<Element | null>(null);
  const open = Boolean(anchorEl);

  const handleClick = useCallback((event: React.MouseEvent<Element>) => {
    setAnchorEl(event.currentTarget);
  }, []);
  const handleClose = useCallback(() => {
    setAnchorEl(null);
    setExpandedKey('');
  }, []);

  const handleAccordionChange = useCallback(
    (key: string) => {
      const isExpanded = key === expandedKey;
      if (isExpanded) {
        setExpandedKey('');
      } else {
        setExpandedKey(key);
      }
    },
    [expandedKey]
  );

  return useMemo(
    () => ({
      open,
      anchorEl,
      expandedKey,
      handleAccordionChange,
      handleClick,
      handleClose,
    }),
    [open, anchorEl, expandedKey, handleAccordionChange, handleClick, handleClose]
  );
};
